module.exports = {
	"api": {
		"url": "",
		"port": "",
		"billingPort": ""
	},
	"date_format": {
		"fulldate_number": "YYYYMMDD"
	},
	"home": {
		"apartmentsGrid": {
			"autoplayInterval": 10000
		}
	},
	"imagesPath": {
		"cities": "../src/images/cities"
	}
};


//////////////////
// WEBPACK FOOTER
// ./config/app.config.json
// module id = 249
// module chunks = 8